<template lang="pug">
  .address-book
    transition-group(name="fade" tag="div")
      .row.address-wrap(v-for="address in addresses" :key="address.id")
        Address(:address="address" edit=true remove=true)

    .row.text-center
      hr
      AddNewAddressBtn

</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex';
  import Address from './Address';
  import AddNewAddressBtn from "./AddNewAddressBtn";

  export default {
    name: "AddressBook",
    components: {
      AddNewAddressBtn,
      Address
    },

    beforeCreate() {
      this.$store.dispatch('addressBook/initAddresses');
    },

    computed: {
      ...mapState('addressBook', [
        'addresses',
        'savingAddress',
        'lastSavedAddress'
      ]),

      ...mapGetters('subscriptions', [
        'activeSubscriptions'
      ])
    },

    methods: {
      ...mapActions('addressBook', [
        'updateSubsModal'
      ]),

      ...mapActions('subscriptions', [
        'updateSubsToUpdate'
      ])
    },

    watch: {
      savingAddress(newVal) {
        //- when ever we save a new address we need to check if that address is new default, if so
        //- prompt the user if they would like to update all their active subs
        if (newVal === false && this.lastSavedAddress.id && this.lastSavedAddress.is_default_shipping && this.activeSubscriptions.length) {
          let subsToUpdate = this.activeSubscriptions.filter(sub => sub.shipping_address_id != this.lastSavedAddress.id);
          //- only pop the modal if there are subs to update
          if (subsToUpdate.length) {
            this.updateSubsToUpdate(subsToUpdate);
            this.updateSubsModal();
          }
        }
      }
    }
  }
</script>

<style scoped lang="stylus">
  .address-book
    .address-wrap
      margin 1.2em 0em

</style>